import React from 'react'
import { Chip, MenuItem, TextField } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import { AdminRole, ROLES } from '../roles'

interface RoleSelectProps {
  value: AdminRole[]
  onChange: (roles: AdminRole[]) => void
  label?: string
  size?: 'small' | 'medium'
  fullWidth?: boolean
  margin?: 'none' | 'dense' | 'normal'
  sx?: SxProps<Theme>
}

/**
 * Multi-select for account/brand roles, rendering the selection as chips.
 */
export const RoleSelect = ({
  value,
  onChange,
  label,
  size,
  fullWidth,
  margin,
  sx,
}: RoleSelectProps) => (
  <TextField
    select
    label={label}
    size={size}
    fullWidth={fullWidth}
    margin={margin}
    sx={sx}
    SelectProps={{
      multiple: true,
      value,
      onChange: (event) => onChange(event.target.value as AdminRole[]),
      renderValue: (selected) => (
        <div className="flex flex-wrap gap-1">
          {(selected as AdminRole[]).map((role) => (
            <Chip key={role} label={role} size="small" color="primary" />
          ))}
        </div>
      ),
    }}
  >
    {ROLES.map((role) => (
      <MenuItem key={role} value={role}>
        {role}
      </MenuItem>
    ))}
  </TextField>
)

export default RoleSelect
